import { useEffect, useMemo, useState } from "react";
import tinycolor from "tinycolor2";

import { defaultChatBotColor } from "./constants";
import { addAlpha, getIsLightColor, invertColor } from "./functions";

function useStyleColors(
  chatBotColor: string,
  widgetPosition: "left" | "right",
) {
  const [invertedColor, setInvertedColor] = useState("");
  const [isLightAccent, setIsLightAccent] = useState(false);

  useEffect(() => {
    const colorToCheck = chatBotColor ?? defaultChatBotColor;
    setInvertedColor(invertColor(colorToCheck));
    setIsLightAccent(getIsLightColor(colorToCheck));
  }, [chatBotColor]);

  const styleColors = useMemo(
    () =>
      ({
        "--chatBotColor": chatBotColor,
        "--invertedColor": invertedColor,
        "--invertedColor10": addAlpha(invertedColor, 0.1),
        "--starterHoverColor": isLightAccent
          ? "#F9FAFB"
          : tinycolor(chatBotColor).setAlpha(0.1).toString(),
        "--borderColor": isLightAccent ? "#E5E7EB" : chatBotColor,
        "--whiteOrChatBotColor": isLightAccent ? "white" : chatBotColor,
        "--chatBotOrDarkColor": isLightAccent ? invertedColor : chatBotColor,
        "--translateHidden": widgetPosition === "left" ? "-50%" : "50%",
      }) as React.CSSProperties,
    [chatBotColor, widgetPosition, invertedColor, isLightAccent],
  );

  return {
    isLightAccent,
    styleColors,
  };
}

export default useStyleColors;
